import { useField } from 'formik'
import * as Styled from './styled'
import { FuelTextFieldEventProps, Props } from './types'

const TextField = ({ onChange, maxLength, innerRef, showError = true, ...props }: Props) => {
  const [field, meta] = useField(props)
  const hasError = showError && meta.touched && meta.error

  function handleChange(event: CustomEvent<FuelTextFieldEventProps>) {
    field.onChange({ target: { name: props.name, value: event.detail.value } })
    onChange?.(event)
  }

  return (
    <Styled.TextField
      {...field}
      {...props}
      data-testid="text-field"
      ref={innerRef}
      state={hasError ? 'error' : 'default'}
      hint={hasError ? meta.error : props.hint}
      maxlength={maxLength}
      onFuel-input={handleChange}
      controlled
    />
  )
}

export default TextField
